var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detial-content-item"},[_c('div',{staticClass:"detial-content-item-name"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"detial-content-item-value"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }